export const currentAppointment = (state) => state.currentAppointment
export const appointments = (state) => state.appointments
export const appointmentStatus = (state) => state.appointmentStatus
export const reminderDtatus = (state) => state.reminderStatus
export const getTimeZones = (state) => state.timeZones
export const getAvailableStatus = (state) => state.availableStatus
export const getFrequencyEnum = (state) => state.frequencyEnum
export const getRecurrenceLimitEnum = (state) => state.recurrenceLimitEnum
export const getRecurrenceFrequencyEnum = (state) => state.recurrenceFrequencyEnum